<template>
  <div class="page-content">
    <div class="page-header">
      <!-- 基本信息 -->
      <owner-info
        :isOwner="false"
        ref="ownerInfo"
        class="owner-info"
        :companyName='companyName'
        :contactPhoneNumber='contactPhoneNumber'
        :quantityOfRentalProperties='quantityOfRentalProperties'
        :walletBalance='walletBalance'
        >
      </owner-info>
      <!-- 费用 -->
      <fee-info
        ref="feeInfo" 
        :isOwner="false"
        :costList.sync='costList'
        :currentMonthElectricity='currentMonthElectricity'
        :currentMonthGasFee='currentMonthGasFee'
        :currentMonthWaterRates='currentMonthWaterRates'
        class="fee-info"
        :className="'company-chart'" >
      </fee-info>
    </div>
    <div class="page-center">
      <!-- 费用明细 -->
      <charge-details
        ref="chargeDetails"
        class="charge-details"
        :totalAmount='totalAmount'
        :paymentDetails='paymentDetails'
        >
      </charge-details>
    </div>
  </div>
</template>

<script>
import ownerInfo from '../ownerInfo'
import feeInfo from '../feeInfo'
import chargeDetails from '../chargeDetails'
export default {
  name: 'tenant',
  components: {
    ownerInfo,
    feeInfo,
    chargeDetails
  },
  data () {
    return {
      companyName: '',
      contactPhoneNumber: '',
      costList: [],
      currentMonthElectricity: 0,
      currentMonthGasFee: 0,
      currentMonthWaterRates: 0,
      paymentDetails: [],
      quantityOfRentalProperties: 0,
      totalAmount: 0,
      walletBalance: 0
    }
  },
  created () {
    this.handleGetInfo()
  },
  methods: {
    handleGetInfo () {
      let startTime = this.$moment(new Date()).startOf('month').format('YYYY/MM/DD HH:mm:ss')
      let endTime = this.$moment(new Date()).add(1, 'M').startOf('month').format('YYYY/MM/DD HH:mm:ss')
      this.$api.tmp.companyUserProfile(startTime, endTime).then((res) => {
        if (res.success) {
          console.log(res)
          this.companyName = res.data.companyName
          this.contactPhoneNumber = res.data.contactPhoneNumber
          this.costList = res.data.costList
          this.currentMonthElectricity = res.data.currentMonthElectricity
          this.currentMonthGasFee = res.data.currentMonthGasFee
          this.currentMonthWaterRates = res.data.currentMonthWaterRates
          this.paymentDetails = res.data.paymentDetails
          this.quantityOfRentalProperties = res.data.quantityOfRentalProperties
          this.totalAmount = res.data.totalAmount
          this.walletBalance = res.data.walletBalance
          console.log(this.costList)
          this.$nextTick(() => {
            this.$refs.feeInfo.handleChartInit()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  margin: 16px;
  // padding: 16px;
  width: calc(100% - 16px);
  height: calc(100% - 32px);
  // background-color: #fff;
  box-sizing: border-box;
  .page-header {
    width: 100%;
    height: 380px;
    display: flex;
    .owner-info, .fee-info {
      width: calc(50% - 8px);
      height: 100%;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 8px;
      margin-right: 16px;
    }
  }
  .page-center {
    margin: 16px 0;
    width: 100%;
    height: 400px;
    padding: 16px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .page-bottom {
    margin: 16px 0;
    width: 100%;
    height: 280px;
    padding: 16px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-sizing: border-box;
  }
}
</style>
